/**
 * @desc 查询原煤消耗月计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthRawCoalResponse>> {
  return defHttp.post({
    url: '/web/plan/month/queryPlanRawCoal',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthRawCoalResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/month/queryPlanRawCoal',
    data,
  });
}
